import * as React from "react";
interface props {
  className?: string;
  fill?: string;
}
const CopySvgIcon = ({ className, fill }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    className={className}
    fill="none"
    viewBox="0 0 20 20"
  >
    <g clipPath="url(#clip0_327_23100)">
      <path
        stroke="#262626"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8.334 10.834a4.166 4.166 0 0 0 6.283.45l2.5-2.5a4.167 4.167 0 0 0-5.892-5.892L9.792 4.317m1.875 4.85a4.165 4.165 0 0 0-6.283-.45l-2.5 2.5a4.167 4.167 0 0 0 5.891 5.892l1.425-1.425"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_327_23100">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CopySvgIcon;
